"use client";

import { env } from "@/env.mjs";
import { BuilderProvider } from "@/services/builder-provider";
import Script from "next/script";
import { useEffect } from "react";

const COOKIE_SCRIPT_SRC = env.NEXT_PUBLIC_COOKIESCRIPT_SOURCE;

export default function CookieScript() {
  const optInTracking = (event: Event) => {
    BuilderProvider.getBuilder().canTrack = true;
  };

  const optOutTracking = (event: Event) => {
    BuilderProvider.getBuilder().canTrack = false;
  };

  const optOnAccept = (event: CustomEventInit<{ categories: string[] }>) => {
    const performanceAccepted = event.detail?.categories.includes("performance") || false;
    BuilderProvider.getBuilder().canTrack = performanceAccepted;
  };

  useEffect(() => {
    // https://www.builder.io/c/docs/gdpr#turning-off-tracking-and-cookies
    BuilderProvider.getBuilder().canTrack = false;

    window.addEventListener("CookieScriptCategory-performance", optInTracking);

    window.addEventListener("CookieScriptAccept", optOnAccept);

    window.addEventListener("CookieScriptAcceptAll", optInTracking);

    window.addEventListener("CookieScriptReject", optOutTracking);

    return () => {
      window.removeEventListener("CookieScriptCategory-performance", optInTracking);
      window.removeEventListener("CookieScriptAccept", optOnAccept);
      window.removeEventListener("CookieScriptAcceptAll", optInTracking);
      window.removeEventListener("CookieScriptReject", optOutTracking);
    };
  });
  return <Script src={COOKIE_SCRIPT_SRC} />;
}
